import { render, staticRenderFns } from "./accountList.vue?vue&type=template&id=4b20fd0a&scoped=true&"
import script from "./accountList.vue?vue&type=script&lang=js&"
export * from "./accountList.vue?vue&type=script&lang=js&"
import style0 from "./accountList.vue?vue&type=style&index=0&id=4b20fd0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20fd0a",
  null
  
)

component.options.__file = "accountList.vue"
export default component.exports